/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import BasicUnit from 'astro/server/unit/basic';

import * as Coords from 'shared/geo/coords';


export default class extends BasicUnit
{
  constructor (cass, planet)
  {
    super(cass, planet);

    this.platform = [];
  }


  installPlatformCoords (coords)
  {
    this.platform.push(coords);
  }


  getPlatform ()
  {
    let collection = [];

    for (const coords of this.platform)
    {
      collection.push(this.getPlanet().getZones().getPlatform(coords));
    }

    return collection;
  }


}
